import store from "@/store";
import router from "@/router";
import NProgress from "nprogress"; // progress bar
import "@/styles/nprogress.less"; // progress less
import { ACCESS_TOKEN, USER } from "@/store/types";
import { getStorageItem, clearStorage } from "@/utils/storage";
import { showMessage } from "@/utils/message";
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/user/login", "/authorization", "/privacy"]; // whitelist
// const applySubject = "/applySubject";
const loginRoutePath = "/user/login";
const bindphoneRoutePath = "/user/bindphone";
const privacyRoutePath = "/privacy";

router.beforeEach((to, from, next) => {
  // start progress bar
  NProgress.start();
  // 获取token
  const token = getStorageItem(ACCESS_TOKEN);
  const user = getStorageItem(USER);
  if (token) {
    // 有token还去登录页或隐私页就清除缓存
    if (to.path === loginRoutePath || to.path === privacyRoutePath) {
      clearStorage();
      next();
    } else {
      // 有手机才进入系统
      if (user.phone) {
        // if (user.status !== 1 && to.path === "/home") {
        //   next({ path: applySubject });
        //   return;
        // }
        // 有token 没有菜单权限信息
        if (!store.getters.permissions && to.path !== "/user/updatepwd") {
          // 获取用户权限菜单信息
          store
            .dispatch("GetUserPermission")
            .then(permissions => {
              // 生成菜单路由
              store.dispatch("GenerateRoutes", permissions).then(addRoutes => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(addRoutes);
                next({ ...to, replace: true });
              });
            })
            .catch(e => {
              console.error(e);
              showMessage("error", "获取用户信息失败");
              store.dispatch("Logout").then(() => {
                // query: { redirect: to.fullPath }
                next({ path: loginRoutePath });
              });
            });
        } else {
          // 没有权限 去403
          // 没有名字 去404
          if (!to.name) {
            next("/404");
          }
          next();
        }
      } else {
        // 没手机就去绑定手机页面
        if (to.path !== bindphoneRoutePath) {
          next("/user/bindphone");
        } else {
          next();
        }
      }
    }
  } else {
    // 没有token 在白名单里面直接过去
    if (whiteList.includes(to.path)) {
      next();
    } else {
      // 没token不在白名单就去登录页
      next({ path: loginRoutePath });
    }
  }
});

router.afterEach(to => {
  // finish progress bar
  NProgress.done();
  store.dispatch("addHistoryTag", to);
});

export default router;
